
class CsfMembreUtils {
  static formatAttributeFromApi(attribute) {
    return attribute?.replace(/\s?\(.*?\)/g, "");
  }

  static objectIsEmpty(object) {
    return object === undefined || Object.keys(object).length === 0;
  }

  /* dashSeparator must be set to true to have - isntead of / as separator */
  static getFormattedDate(dateString) {
    if (dateString == null || dateString === '') {
      return '';
    }

    const date = new Date(dateString);

    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };

    // Format date as dd/mm/yyyy
    let formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);

    // Replace '-' with '/'  for final format: dd/mm/yyyy
    return formattedDate.replaceAll('-', '/')
  }

  static limitCharacter(text= '', limit) {
      return text.slice(0, limit) + (text.length > limit ? "..." : "");
  }
}

export default CsfMembreUtils;
